import React, { useState, useEffect } from 'react';
import { DialogTitle, Grid, Button, DialogContent, DialogActions, Dialog, TextField } from '@mui/material';
import Controls from "./controls/Controls";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

export default function OverdueDocumentsDialog({ open, handleClose, formData, setFormData, handleFormSubmit, enabled }) {
  const [formElements, setFormElements] = useState([]);
  const [prevDocuments, setPrevDocuments] = useState([]);

  useEffect(() => {
    const filteredDocuments = formData?.otherDocuments?.filter(item => item.documentTypeId === 171) || [];
    if (filteredDocuments.length > 0) {
      setFormElements(filteredDocuments);
    } else if (enabled) {
      setFormElements([{
        id: null,
        quantity: "",
        comment: "",
        documentTypeId: 171
      }]);
    } else {
      setFormElements([]);
    }
  }, [formData]);

  useEffect(() => {
    if (open) {
      setPrevDocuments(formData?.otherDocuments?.filter(item => item.documentTypeId !== 171) || []);
    }
  }, [open]);

  const isNumber = (value) => {
    const reg = /^[0-9]+$/;
    return reg.test(value);
  };

  const handleElementChange = (event, index) => {
    const { name, value } = event.target;
    if (name === "quantity" && !isNumber(value) && value !== "") {
      return;
    }
    setFormElements((prevElements) => {
      const updatedElements = [...prevElements];
      updatedElements[index] = {
        ...updatedElements[index],
        [name]: value
      };
      setFormData({ ...formData, otherDocuments: updatedElements });
      return updatedElements;
    });
  };

  const validate = () => {

    if (formElements.length > 0 && (formElements[0].quantity !== null && formElements[0].quantity > 0 && formElements[0].quantity !== '') && (formElements[0].comment === "" || formElements[0].comment === null)) {
      alert("Dodaj komentarz lub wyliczenia");
      return false;
    }
    if(formElements[0].quantity === '' && formElements[0].comment !== ""){
      alert("Podaj liczbę");
      return false;
    }
    if(formElements[0].quantity === '' && formElements[0].comment === ""){
      handleClearForm()
      return true;
    }
    return true;
  };

  const localHandleFormSubmit = () => {
    
    if (validate()) {
      handleFormSubmit(prevDocuments, true);
    }
  }

  const handleClearForm = () => {
    // Resetujemy formElements do początkowej wartości
    const initialFormElements = [{
      id: null,
      quantity: "",
      comment: "",
      documentTypeId: 171
    }];

    setFormElements(initialFormElements);

    // Usuwamy dokumenty o documentTypeId: 171 z otherDocuments w formData
    const updatedOtherDocuments = formData?.otherDocuments?.filter(item => item.documentTypeId !== 171) || [];

    // Aktualizujemy formData z przefiltrowaną listą dokumentów
    setFormData({ ...formData, otherDocuments: updatedOtherDocuments });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {enabled ? (
          <DialogTitle id="alert-dialog-title">Dodaj dokument</DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">Podgląd</DialogTitle>
        )}

        <Divider />
        <DialogContent>
          <form>
            {(formElements && formElements.length > 0) ? (
              formElements.map((element, index) => (
                <Grid
                  key={index}
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 4 }}
                >
                  <Grid item xs={8}>
                    <Box mt={1}>
                      <label>
                        Łączna liczba zaległych dokumentów zaksięgowanych w bieżącym okresie:
                      </label>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Controls.Input
                      name="quantity"
                      value={String(element.quantity) || ''}
                      onChange={(e) => handleElementChange(e, index)}
                      placeholder="Podaj liczbę"
                      disabled={!enabled}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      name="comment"
                      value={element.comment}
                      multiline
                      onChange={(e) => handleElementChange(e, index)}
                      placeholder="Wprowadź tekst"
                      label="Komentarz lub wyliczenia (do wglądu tylko przez 7PM)"
                      margin="dense"
                      rows={6}
                      inputProps={{
                        maxLength: 1990,
                      }}
                      disabled={!enabled}
                      fullWidth
                      focused
                    />
                  </Grid>
                </Grid>
              ))
            ) : (
              <p style={{ fontSize: 18 }}>Brak elementów...</p>
            )}
            <Box sx={{ m: '30px' }} />
          </form>
        </DialogContent>
        <DialogActions>
          {enabled ? (
            <>
              <Button onClick={handleClearForm} color="secondary" variant="contained">
                Wyczyść
              </Button>
              <Box sx={{ flexGrow: 1 }} /> {/* Dodany spacer, aby przyciski po prawej stronie były oddzielone */}
              <Button onClick={handleClose} color="secondary" variant="outlined">
                Anuluj
              </Button>
              <Button color="primary" onClick={localHandleFormSubmit} variant="contained">
                Zapisz
              </Button>
            </>
          ) : (
            <Button onClick={handleClose} color="primary" variant="contained">
              Zamknij
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}